import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotice } from '../data/unstuckContent';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, []);
  return <AnimatePresence data-id="element-186" data-mp="2qvrdch168edh">
      {visible && <motion.aside initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Recent purchase" className="fixed bottom-24 left-4 z-30 hidden max-w-[19rem] items-start gap-3 border border-charcoal-600 bg-charcoal-900/95 px-4 py-3 shadow-card backdrop-blur lg:bottom-6 lg:flex" data-id="element-187" data-mp="2lvv70b504aur">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" strokeWidth={2} aria-hidden="true" data-id="element-188" data-mp="b324kexbhvbw" />
          <div className="min-w-0" data-id="element-189" data-mp="1z52says6s1u5">
            <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-champagne" data-id="element-190" data-mp="1z49krvlel8ay">
              Verified purchase
            </p>
            <p className="mt-1 text-[13px] leading-snug text-ivory-100" data-id="element-191" data-mp="286ackcxvb258">
              <span className="font-medium" data-id="element-192" data-mp="285hcfutezaw2">{purchaseNotice.name}</span> from{' '}
              {purchaseNotice.location} bought UNSTUCK
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-193" data-mp="1fgtp7tp3ubfv">
              {purchaseNotice.minutesAgo} minutes ago
            </p>
          </div>
          <button type="button" onClick={() => setVisible(false)} className="-mr-1 -mt-1 shrink-0 p-1 text-muted transition-colors duration-150 ease-out hover:text-ivory-100" data-id="element-194" data-mp="1p7ejx61nqvti">
            <XIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-195" data-mp="wqlo1h4ytv2b" />
            <span className="sr-only" data-id="element-196" data-mp="20216v92w5xla">Dismiss notification</span>
          </button>
        </motion.aside>}
    </AnimatePresence>;
}